export enum TimeUnit {
    Seconds = "s",
    Minutes = "m",
    Hours = "h",
}
